import { render, staticRenderFns } from "./TaskOperationConfig.vue?vue&type=template&id=6bf5255f&scoped=true"
import script from "./TaskOperationConfig.vue?vue&type=script&lang=js"
export * from "./TaskOperationConfig.vue?vue&type=script&lang=js"
import style0 from "./TaskOperationConfig.vue?vue&type=style&index=0&id=6bf5255f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf5255f",
  null
  
)

export default component.exports